import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-info',
  templateUrl: './job-info.component.html',
  styleUrls: ['./job-info.component.scss']
})
export class JobInfoComponent implements OnInit {

  @Input('backLink') backLink: string = '/job-portal/applications';
  @Input('backQueryParms') backQueryParms: any = {};
  @Input('backLinkMsg') backLinkMsg: any = 'Back to Applications';
  @Input('jobDetail') jobDetail: any = null;  

  constructor() { }

  ngOnInit() {
  }

}
